import React, { useState, useEffect, useCallback } from "react";
import axiosInstance from "../../utils/axiosConfig";
import { ReactComponent as Line } from "../../assets/Line 2.svg";
import { ReactComponent as EditIcon } from "../../assets/edit.svg";
import { ReactComponent as CheckIcon } from "../../assets/check.svg";

const CornerSvg = () => (
    <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.96497 0V1.52681H1.62135V8.44236H2.76566e-05V0H8.96497Z" fill="#00739F" fillOpacity="0.5" />
    </svg>
);

const UserInfoSection = ({ userInfo, updateUserData }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [newName, setNewName] = useState(userInfo.name || "Аноним");
    const [isAnimationComplete, setIsAnimationComplete] = useState(false);
    const telegramData = window.Telegram?.WebApp?.initDataUnsafe?.user || {};
    const telegramUsername = telegramData.username || "";

    // Обновляем newName когда меняется userInfo.name
    useEffect(() => {
        setNewName(userInfo.name || "Аноним");
    }, [userInfo.name]);

    useEffect(() => {
        // Устанавливаем флаг анимации завершенной после задержки
        const timer = setTimeout(() => {
            setIsAnimationComplete(true);
        }, 1200); // Немного больше полной длительности анимаций

        return () => clearTimeout(timer);
    }, []);

    // Сохранение имени пользователя
    const handleSaveName = useCallback((nameToSave = newName, usernameToSave = telegramUsername, shouldResetEdit = true) => {
        if (!nameToSave.trim()) {
            nameToSave = "Аноним";
        }

        axiosInstance.post('/profile/save-name', {
            name: nameToSave,
            username: usernameToSave
        })
            .then((res) => {
                if (res.data.success) {
                    updateUserData({ name: nameToSave, username: usernameToSave });
                    if (shouldResetEdit) setIsEditing(false);
                }
            })
            .catch((error) => console.log("Ошибка сохранения имени", error));
    }, [newName, telegramUsername, updateUserData]);

    // Проверяем, нужно ли обновить username на сервере
    useEffect(() => {
        if (isAnimationComplete && telegramUsername && userInfo.username !== telegramUsername) {
            handleSaveName(userInfo.name, telegramUsername, false);
        }
    }, [isAnimationComplete, telegramUsername, userInfo.username, handleSaveName, userInfo.name]);

    return (
        <div className="profile-info-section">
            <div className="corner-container">
                <div className="corner top-left"><CornerSvg /></div>
                <div className="corner top-right"><CornerSvg /></div>
                <div className="corner bottom-left"><CornerSvg /></div>
                <div className="corner bottom-right"><CornerSvg /></div>

                <div className="name-container">
                    {isEditing ? (
                        <div className="name-display">
                            <div className="invisible-spacer"></div>
                            <input
                                type="text"
                                value={newName}
                                onChange={(e) => setNewName(e.target.value)}
                                className="name-input"
                                placeholder="Введите ваше имя"
                                maxLength={30}
                                autoFocus
                            />
                            <button
                                className="name-edit-btn confirm-btn"
                                onClick={() => handleSaveName()}
                            >
                                <CheckIcon className="check-icon" />
                            </button>
                        </div>
                    ) : (
                        <div className="name-display">
                            <div className="invisible-spacer"></div>
                            <div className="name-username-container">
                                <h2 className="profile-name">{userInfo.name}</h2>
                                {telegramUsername && <p className="profile-username">@{telegramUsername}</p>}
                            </div>
                            <button
                                className="name-edit-btn"
                                onClick={() => isAnimationComplete && setIsEditing(true)}
                                disabled={!isAnimationComplete}
                            >
                                <EditIcon className="edit-icon" />
                            </button>
                        </div>
                    )}
                </div>

                <div className="line-container">
                    <Line />
                </div>

                <div className="profile-stats-vertical">
                    <div className="stat-row">
                        <div className="stat-label">🏆 Позиция в рейтинге</div>
                        <div className="stat-value-container">
                            <div className="corner top-left"><CornerSvg /></div>
                            <div className="corner top-right"><CornerSvg /></div>
                            <div className="corner bottom-left"><CornerSvg /></div>
                            <div className="corner bottom-right"><CornerSvg /></div>
                            <div className="stat-value">{userInfo.rank > 0 ? `#${userInfo.rank}` : "—"}</div>
                        </div>
                    </div>

                    <div className="stat-row">
                        <div className="stat-label">💎 Кол-во баллов</div>
                        <div className="stat-value-container">
                            <div className="corner top-left"><CornerSvg /></div>
                            <div className="corner top-right"><CornerSvg /></div>
                            <div className="corner bottom-left"><CornerSvg /></div>
                            <div className="corner bottom-right"><CornerSvg /></div>
                            <div className="stat-value">{userInfo.totalScore || 0}</div>
                        </div>
                    </div>

                    <div className="stat-row">
                        <div className="stat-label">📚 Пройденные уроки</div>
                        <div className="stat-value-container">
                            <div className="corner top-left"><CornerSvg /></div>
                            <div className="corner top-right"><CornerSvg /></div>
                            <div className="corner bottom-left"><CornerSvg /></div>
                            <div className="corner bottom-right"><CornerSvg /></div>
                            <div className="stat-value">{userInfo.completedLessons || 0}/{userInfo.totalLessons || 18}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserInfoSection; 